import Http from '../core/http/http.service';

class ProjectService {
    search(request: ProjectSearchWebRequest): Promise<ProjectSearchResultViewModel> {
        return Http.get<ProjectSearchResultViewModel>('project/search', request);
    }
}

export default new ProjectService();
